// @core/api/endpoints/task/list_task_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTaskPoliciesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List task policies
 * Returns task policies, optionally filtered by scope entity type.
 */
export async function ListTaskPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTaskPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-policies`;
  const requestOptions = options;
  return client.get<ListTaskPoliciesResponse>(requestPath, { ...requestOptions, params });
}
